import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import PreviewHeader from "../components/business-sheet/PreviewHeader";
import BusinessSheetTemplate from "../components/business-sheet/BusinessSheetTemplate";
import { SpinnerPage } from "../components/global/Spinner";
import BlockButton from "../components/chat/BlockButton";
import useBlockList from "../hooks/useBlockList";
import useLocalStorage from "../hooks/useLocalStorage";
import { getUserSheetById } from "../api/businessSheet";
import { messages } from "../constants/messages";

const Preview = () => {
  const { id } = useParams();
  const [businessSheetData, setBusinessSheetData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  // 解除後にシートを取り直すためのキー
  const [reloadKey, setReloadKey] = useState(0);
  const { getValue } = useLocalStorage();
  // ログイン判定は localStorage のみ（checkAuth は期限切れ Cookie のゲストを /login へ飛ばすため使わない）
  const currentUserId = useMemo(
    () => getValue("businessSheetData")?.userId,
    [getValue],
  );
  const canBlock = !!currentUserId && currentUserId !== id;
  const { isBlocked, isLoaded, markBlocked, markUnblocked } = useBlockList({
    enabled: canBlock,
  });

  useEffect(() => {
    const getData = async () => {
      const response = await getUserSheetById(id);
      // handleApiResponse はエラー時もレスポンスボディを data に入れて返すため、
      // ステータスで判定しないと 404 の本文を空のシートとして描画してしまう
      if (response.status !== 200) {
        setNotFound(true);
        return;
      }
      setBusinessSheetData(response.data);
    };
    getData();
  }, [id, reloadKey]);

  // Issue #126: ブロック中の相手は API が 404。ブロックした本人にだけ解除の導線を出す
  const handleUnblockedFromNotFound = (targetUserId) => {
    markUnblocked(targetUserId);
    setNotFound(false);
    setReloadKey((key) => key + 1);
  };

  if (notFound) {
    const showUnblock = canBlock && isLoaded && isBlocked(id);
    return (
      <>
        <PreviewHeader />
        {showUnblock ? (
          <>
            <p className="preview-not-found">{messages.blockedUserPreview}</p>
            <BlockButton
              targetUserId={id}
              userName="このユーザー"
              isBlocked={true}
              onUnblocked={handleUnblockedFromNotFound}
            />
          </>
        ) : (
          <p className="preview-not-found">{messages.userNotFound}</p>
        )}
      </>
    );
  }

  return (
    <>
      <PreviewHeader />
      {businessSheetData ? (
        <>
          {canBlock && (
            <BlockButton
              targetUserId={id}
              userName={businessSheetData.userName}
              isBlocked={isBlocked(id)}
              onBlocked={markBlocked}
              onUnblocked={markUnblocked}
            />
          )}
          <BusinessSheetTemplate data={businessSheetData} isEdit={false} />
        </>
      ) : (
        <SpinnerPage />
      )}
    </>
  );
};

export default Preview;
